import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import {AuthContext} from "../context/auth";

export default class Home extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        console.log(context);
    }

    render() {
        if (this.authContext.role && this.authContext.role !== "guest") {
            return <Redirect to="/" />;
        }

        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h2 className="m-0 font-weight-bold">  Guest access denied: {this.authContext.username}</h2></div>
                    <div className="card-body">
                        Waiting for permissions update...
                    </div>
                </div>
            </div>
        );
    }
}

